export const ARRAY_ERROR = 'form/array-error'
export const FORM_ERROR = 'form/form-error'

export const fieldSubscriptionItems = [
  'active',
  'data',
  'dirty',
  'dirtySinceLastSubmit',
  'error',
  'initial',
  'invalid',
  'length',
  'pristine',
  'submitError',
  'submitFailed',
  'submitSucceeded',
  'touched',
  'valid',
  'value',
  'visited'
]

export const formSubscriptionItems = [
  'active',
  'dirty',
  'dirtyFields',
  'dirtySinceLastSubmit',
  'error',
  'errors',
  'hasSubmitErrors',
  'hasValidationErrors',
  'initialValues',
  'invalid',
  'pristine',
  'submitting',
  'submitError',
  'submitErrors',
  'submitFailed',
  'submitSucceeded',
  'touched',
  'valid',
  'validating',
  'values',
  'visited'
]
